import { ReactNode } from 'react';

import { Box } from 'components/Box';
import { AnchorButton } from 'components/Button/AnchorButton';
import { CmsApiPage } from 'modules/cms/api/types/CmsApiPage';
import { getContentPageUrl } from 'modules/cms/helpers';
import { gutterWidth } from 'theme/theme';

import {
  AmpCardsBlockImageSize,
  CmsAmpCardsBlockCardData,
} from './CmsAmpCardsBlock.types';
import { CmsAmpCardsBlockCard } from './CmsAmpCardsBlockCard';
import { CmsAmpCardsBlockCardContainer } from './CmsAmpCardsBlockCardContainer';

type Data = {
  headline?: string | null | undefined;
  subheadline?: string | null | undefined;
  buttonText?: string | null | undefined;
  buttonUrl?: string | null | undefined;
  imageSize?: AmpCardsBlockImageSize;
  cards: Array<CmsAmpCardsBlockCardData>;
  maxLength?: number;
  seeMoreText?: string;
};

type Props = {
  content: CmsApiPage;
  data: Data;
  blockId: string;
};

export function CmsAmpCardsBlock({
  content,
  data: {
    headline,
    subheadline,
    imageSize,
    buttonText,
    buttonUrl,
    cards,
    maxLength = 3,
    seeMoreText,
  },
  blockId,
}: Props) {
  const pageUrl = getContentPageUrl({ content });
  const rowLength = Math.min(maxLength, 4);
  return (
    <CmsAmpCardsBlockCardContainer
      headline={headline}
      subheadline={subheadline}
      buttonText={buttonText}
      buttonUrl={buttonUrl}
    >
      {cards
        .slice(0, maxLength || cards.length)
        .map<ReactNode>((card, index) => (
          <Box // eslint-disable-next-line react/no-array-index-key
            key={index}
            width={[1, null, 1 / rowLength]}
            maxWidth={320}
            px={[0, null, gutterWidth / 2]}
            py={[gutterWidth / 2, null, 0]}
          >
            <CmsAmpCardsBlockCard
              maxLength={rowLength}
              card={card}
              imageSize={imageSize}
            />
          </Box>
        ))}

      {maxLength && cards.length > maxLength && (
        <Box mt={24}>
          <AnchorButton
            href={`${pageUrl}#cms-block-${blockId}`}
            variant="secondary"
          >
            {seeMoreText || getText('See All')}
          </AnchorButton>
        </Box>
      )}
    </CmsAmpCardsBlockCardContainer>
  );
}
